import { truncateString } from "@/utils";
import FilterItem from "./FilterItem.vue";
import FiltersMixin from "@/mixins/FiltersMixin.vue";
import CustomFilterBody from "./bodies/CustomFilterBody.vue";
export default {
  name: "CustomFilter",
  components: {
    FilterItem,
    CustomFilterBody
  },
  emits: ["apply", "cleared"],
  expose: ["openDropdown"],
  mixins: [FiltersMixin],
  props: {
    items: {
      type: Object,
      required: true,
      default: () => ({
        filterState: {
          selected: [],
          list: []
        },
        isModified: false,
        select: () => {},
        deselect: () => {},
        clear: () => {},
        apply: () => {},
        listSearch: () => {}
      })
    },
    item_key: {
      type: String,
      default: 'item'
    },
    item_name: {
      type: String,
      default: 'item_name'
    },
    type: {
      type: String,
      default: 'custom'
    },
    title: {
      type: String,
      default: 'All Items'
    },
    bodyTitle: {
      type: String,
      default: 'Item'
    },
    filter_id: String,
    search_placeholder: String,
    icon: String
  },
  computed: {
    getTitle() {
      let joinedContents = this.items.selected.map(el => el?.[`${this.item_name}`]).join(", ");
      joinedContents = joinedContents.length > 0 ? joinedContents : this.title;
      return truncateString(joinedContents, 16);
    },
    getSelectedTitle() {
      const joined = this.items.selected.map(el => el?.[`${this.item_name}`]).join(", ");
      return joined.length > 0 ? truncateString(joined, 200) : "";
    }
  },
  methods: {
    handleSearch({
      value
    }) {
      // If value is empty, clear the searching state
      if (value.length === 0) {
        this.items.searching = false;
      }
      this.items.listSearch(value, [this.item_key]);
    },
    handleClear() {
      this.items.clear();
    },
    onRestoreSearch() {
      this.items.restoreSearch();
    },
    handleSelect(val) {
      this.items.select(val, this.item_key);
    },
    handleSelectOnly(val) {
      this.items.selectOnly(val, this.item_key);
    },
    handleDeselect(val) {
      this.items.deselect(val, this.item_key);
    },
    onHidden() {
      this.items.clearDraft();
    },
    handleClearAll() {
      this.items.clear();
      this.$emit('cleared');
    },
    openDropdown(initializer = async () => {}, callback = () => {}) {
      this.openAsyncFilterDropdown(this.$refs?.[`${this.type}FilterItem`], initializer, callback);
    }
  }
};